export default __webpack_public_path__ + "static/media/logoSuvinil.143fae37.jpg";